import Vue from "vue";
import Router from "vue-router";
//引入在路由中需要用到的组件

Vue.use(Router); //加载全局组件Router

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default new Router({
  //mode:'history', //路由模式:默认为hash,如果改为history,则需要后端进行配合
  routes: [
    {
      path: "/login",
      name: "login",
      component: (resolve) => require(["@/views/login/login"], resolve),
    },
    {
      path: "/register",
      name: "register",
      component: (resolve) => require(["@/views/login/register"], resolve),
    },
    {
      path: "/retpwd",
      name: "retpwd",
      component: (resolve) => require(["@/views/login/retpwd"], resolve),
    },
    {
      path: "/",
      component: (resolve) => require(["@/views/layout"], resolve),
      children: [
        {
          path: "",
          name: "index",
          component: (resolve) => require(["@/views/index"], resolve),
        },
        // 合同履约
        {
          path: "contract",
          name: "contract",
          component: (resolve) => require(["@/views/contract/index"], resolve),
          children: [
            {
              path: "contractView",
              name: "contractView",
              // meta无影响
              meta: { title: "合同履约" },
              component: (resolve) =>
                require(["@/views/contract/components/contract-left"], resolve),
            },
            {
              path: "searchContract",
              name: "searchContract",
              meta: { title: "合同搜索" },
              component: (resolve) =>
                require([
                  "@/views/contract/components/searchContract",
                ], resolve),
            },
            {
              path: "contractDetail/:id",
              name: "contractDetail",
              // meta无影响
              meta: { title: "合同详情" },
              component: (resolve) =>
                require([
                  "@/views/contract/components/contractDetail",
                ], resolve),
            },
          ],
        },
        {
          path: "common",
          name: "common",
          component: (resolve) =>
            require(["@/views/left-right-layout"], resolve),
          children: [
            {
              path: "dynamics/:tab",
              name: "dynamics",
              meta: { title: "信用动态" },
              component: (resolve) => require(["@/views/dynamics"], resolve),
            },
            {
              path: "article/:from/:id",
              name: "article",
              meta: { title: "文章" },
              component: (resolve) => require(["@/views/article"], resolve),
            },
            {
              path: "policy",
              name: "policy",
              meta: { title: "政策法规" },
              component: (resolve) => require(["@/views/policy"], resolve),
            },
            {
              path: "risks",
              name: "risks",
              meta: { title: "风险提示" },
              component: (resolve) => require(["@/views/risks"], resolve),
            },
            {
              path: "special",
              name: "special",
              meta: { title: "专项治理" },
              component: (resolve) => require(["@/views/special"], resolve),
            },
            {
              path: "research",
              name: "research",
              meta: { title: "信用研究" },
              component: (resolve) => require(["@/views/research"], resolve),
            },
            {
              path: "rewardsPunishments",
              name: "rewardsPunishments",
              meta: { title: "联合奖惩" },
              component: (resolve) =>
                require(["@/views/rewardsPunishments"], resolve),
            },
            {
              path: "typical",
              name: "typical",
              meta: { title: "诚信宣传" },
              component: (resolve) => require(["@/views/typical"], resolve),
            },
            {
              path: "industries",
              name: "industries",
              meta: { title: "行业信用" },
              component: (resolve) => require(["@/views/industries"], resolve),
            },
            {
              path: "bothPublic",
              name: "bothPublic",
              meta: { title: "双罚公示" },
              component: (resolve) => require(["@/views/bothPublic"], resolve),
            },
            {
              path: "notice",
              name: "notice",
              meta: { title: "通知公告" },
              component: (resolve) => require(["@/views/notice"], resolve),
            },
            {
              path: "letterEasy",
              name: "letterEasy",
              meta: { title: "信易+" },
              component: (resolve) => require(["@/views/letterEasy"], resolve),
            },
            {
              path: "infoPublicity",
              name: "infoPublicity",
              meta: { title: "信用资讯公示" },
              component: (resolve) =>
                require(["@/views/infoPublicity"], resolve),
            },
          ],
        },
        {
          path: "server/:type",
          name: "server",
          meta: { title: "信用服务" },
          component: (resolve) => require(["@/views/server"], resolve),
        },
        {
          path: "publicity/:type",
          name: "publicity",
          meta: { title: "信用公示" },
          component: (resolve) => require(["@/views/publicity"], resolve),
        },
        {
          path: "promise",
          name: "promise",
          meta: { title: "信用承诺" },
          component: (resolve) => require(["@/views/promise"], resolve),
        },
        {
          path: "promiseDetail",
          name: "promiseDetail",
          meta: { title: "信用承诺详情" },
          component: (resolve) => require(["@/views/promiseDetail"], resolve),
        },
        {
          path: "adjuDetail",
          name: "adjuDetail",
          meta: { title: "行政裁决详情" },
          component: (resolve) => require(["@/views/adjuDetail"], resolve),
        },
        {
          path: "creditCourtDecisionDetail",
          name: "creditCourtDecisionDetail",
          meta: { title: "司法判决详情" },
          component: (resolve) =>
            require(["@/views/creditCourtDecisionDetail"], resolve),
        },
        {
          path: "createPromise",
          name: "createPromise",
          meta: { title: "信用承诺申报" },
          component: (resolve) => require(["@/views/createPromise"], resolve),
        },
        {
          path: "searchArticle",
          name: "searchArticle",
          meta: { title: "资讯文章" },
          component: (resolve) => require(["@/views/searchArticle"], resolve),
        },
        {
          path: "antiDisease",
          name: "antiDisease",
          meta: { title: "防疫红黑榜" },
          component: (resolve) => require(["@/views/antiDisease"], resolve),
        },
        {
          path: "antiDiseaseList",
          name: "antiDiseaseList",
          component: (resolve) => require(["@/views/antiDiseaseList"], resolve),
        },
        {
          path: "company",
          name: "company",
          meta: { title: "公司详情" },
          component: (resolve) => require(["@/views/company"], resolve),
        },
        {
          path: "searchCompanyList",
          name: "searchCompanyList",
          meta: { title: "公司" },
          component: (resolve) =>
            require(["@/views/searchCompanyList"], resolve),
        },
        {
          path: "user",
          name: "user",
          component: (resolve) => require(["@/views/user/index"], resolve),
          children: [
            {
              path: "basic",
              name: "basic",
              meta: { title: "个人中心" },
              component: (resolve) => require(["@/views/user/basic"], resolve),
            },
            {
              path: "myfeedback",
              name: "myfeedback",
              meta: { title: "用户反馈" },
              component: (resolve) =>
                require(["@/views/user/myfeedback"], resolve),
            },
            {
              path: "myPromise",
              name: "myPromise",
              meta: { title: "我的承诺" },
              component: (resolve) =>
                require(["@/views/user/myPromise"], resolve),
            },
            {
              path: "myappeal",
              name: "myappeal",
              meta: { title: "异议申诉" },
              component: (resolve) =>
                require(["@/views/user/myappeal"], resolve),
            },
            {
              path: "myRepair",
              name: "myRepair",
              meta: { title: "我的信用修复" },
              component: (resolve) =>
                require(["@/views/user/myRepair"], resolve),
            },
            {
              path: "repair",
              name: "repair",
              meta: { title: "信用修复" },
              component: (resolve) => require(["@/views/user/repair"], resolve),
            },
            {
              path: "historical-declaration",
              name: "historical-declaration",
              meta: { title: "历史申报" },
              component: (resolve) =>
                require(["@/views/user/historical-declaration"], resolve),
            },
            {
              path: "attestation",
              name: "attestation",
              component: (resolve) =>
                require(["@/views/user/attestation"], resolve),
            },
          ],
        },
        {
          path: "userFeedback",
          name: "userFeedback",
          meta: { title: "用户反馈" },
          component: (resolve) =>
            require(["@/views/user/userFeedback"], resolve),
        },
        {
          path: "noticerelname",
          name: "noticerelname",
          meta: { title: "实名认证须知" },
          component: (resolve) =>
            require(["@/views/user/noticerelname"], resolve),
        },
        {
          path: "netapplication",
          name: "netapplication",
          meta: { title: "网站声明" },
          component: (resolve) =>
            require(["@/views/user/netapplication"], resolve),
        },
        {
          path: "about",
          name: "about",
          meta: { title: "关于我们" },
          component: (resolve) => require(["@/views/about"], resolve),
        },
        {
          path: "mattersDirectory",
          name: "mattersDirectory",
          meta: { title: "事项说明" },
          component: (resolve) =>
            require(["@/views/user/mattersDirectory"], resolve),
        },
        {
          path: "mattersDetail",
          name: "mattersDetail",
          meta: { title: "事项明细" },
          component: (resolve) =>
            require(["@/views/user/mattersDetail"], resolve),
        },
        {
          path: "repair",
          name: "repair",
          meta: { title: "信用修复" },
          component: (resolve) => require(["@/views/repair/main"], resolve),
          children: [
            {
              path: "country",
              name: "country",
              meta: { title: "信用修复" },
              component: (resolve) =>
                require(["@/views/repair/country"], resolve),
            },
            {
              path: "province",
              name: "province",
              meta: { title: "信用修复" },
              component: (resolve) =>
                require(["@/views/repair/province"], resolve),
            },
            {
              path: "city",
              name: "city",
              meta: { title: "信用修复" },
              component: (resolve) => require(["@/views/repair/city"], resolve),
            },
            {
              path: "area",
              name: "area",
              meta: { title: "信用修复(肥城)" },
              component: (resolve) => require(["@/views/repair/area"], resolve),
            },
            {
              path: "list",
              name: "list",
              meta: { title: "信用修复公示" },
              component: (resolve) => require(["@/views/repair/list"], resolve),
            },
          ],
        },
        {
          path: "column",
          name: "column",
          meta: { title: "专题专栏" },
          component: (resolve) => require(["@/views/column"], resolve),
        },
        {
          path: "supervision",
          name: "supervision",
          meta: { title: "信用评价" },
          component: (resolve) => require(["@/views/supervision"], resolve),
        },
        {
          path: "social",
          name: "social",
          meta: { title: "信用社区" },
          component: (resolve) => require(["@/views/social/index"], resolve),
        },
        {
          path: "people",
          name: "people",
          meta: { title: "信用社区" },
          component: (resolve) => require(["@/views/social/people"], resolve),
        },
        {
          path: "promisePolitics",
          name: "promisePolitics",
          meta: { title: "政务承诺" },
          component: (resolve) => require(["@/views/promisePolitics"], resolve),
        },
      ],
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
});
